export enum Blindleistungsverfahren {
    COS_PHI_UNTERERREGT = 'COS_PHI_UNTERERREGT',
    COS_PHI_UEBERERREGT = 'COS_PHI_UEBERERREGT',
    COS_PHI_90_UNTERERREGT = 'COS_PHI_90_UNTERERREGT',
    COS_PHI_90_UEBERERREGT = 'COS_PHI_90_UEBERERREGT',
    COS_PHI_95_UNTERERREGT = 'COS_PHI_95_UNTERERREGT',
    COS_PHI_95_UEBERERREGT = 'COS_PHI_95_UEBERERREGT',
    COS_PHI_97_UNTERERREGT = 'COS_PHI_97_UNTERERREGT',
    COS_PHI_97_UEBERERREGT = 'COS_PHI_97_UEBERERREGT',
    COS_PHI_98_UNTERERREGT = 'COS_PHI_98_UNTERERREGT',
    COS_PHI_98_UEBERERREGT = 'COS_PHI_98_UEBERERREGT',
    COS_PHI_P = 'COS_PHI_P',
    COS_PHI_P_UNTERERREGT = 'COS_PHI_P_UNTERERREGT',
    COS_PHI_P_UEBERERREGT = 'COS_PHI_P_UEBERERREGT',
    QP = 'QP',
    QP_UNTERERREGT = 'QP_UNTERERREGT',
    QP_UEBERERREGT = 'QP_UEBERERREGT',
    QU = 'QU',
    COS_PHI_1 = 'COS_PHI_1'

}

export class BlindleistungsverfahrenItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): BlindleistungsverfahrenItem[] {
        return [
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_UNTERERREGT, 'cos phi = untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_UEBERERREGT, 'cos phi = übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_90_UEBERERREGT, 'cos phi = 0,90 übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_90_UNTERERREGT, 'cos phi = 0,90 untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_95_UEBERERREGT, 'cos phi = 0,95 übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_95_UNTERERREGT, 'cos phi = 0,95 untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_97_UEBERERREGT, 'cos phi = 0,97 übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_97_UNTERERREGT, 'cos phi = 0,97 untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_98_UEBERERREGT, 'cos phi = 0,98 übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_98_UNTERERREGT, 'cos phi = 0,98 untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_P, 'cos phi = P'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_P_UNTERERREGT, 'cos phi = P untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_P_UEBERERREGT, 'cos phi = P übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.COS_PHI_1, 'cos phi = 1'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.QP, 'Q(P)'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.QP_UEBERERREGT, 'Q(P) übererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.QP_UNTERERREGT, 'Q(P) untererregt'),
            new BlindleistungsverfahrenItem(Blindleistungsverfahren.QU, 'Q(U)'),
        ];
    }

}
